// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"O9-z"};